const parseNeeded = [
  'Whiff%', 'Hard%', 'SwSp%', 'LA(°)', 'Swing%'
]

export const parseNumber = (str) => {
  let numString = str.slice(0, -1)
  return parseFloat(numString)
}


export const sortByTag = (data, target, reverse=false) => {
  if (target === 'Player' || target === 'Rk') return data
  if (data[0][target] === undefined) return data
  const valComp = (a, b) => {
    if (b[target] === '-') return -1
    if (a[target] === '-') return 1
    let aval = a[target], bval = b[target]
    if (parseNeeded.includes(target) && isNaN(aval)) {
      aval = parseNumber(aval)
      bval = parseNumber(bval)
    }
    if (aval >= bval) return -1
    return 1
  }
  const revValComp = (a, b) => {
    if (b[target] === '-') return -1
    if (a[target] === '-') return 1
    let aval = a[target], bval = b[target]
    if (parseNeeded.includes(target) && isNaN(aval)) {
      aval = parseNumber(aval)
      bval = parseNumber(bval)
    }
    if (aval <= bval) return -1
    return 1
  }

  let rdata = [...data]

  if (reverse) rdata.sort(revValComp)
  else rdata.sort(valComp)
  
  return rdata
}

export const diffVal = (data, target, idx) => {
  if (parseNeeded.includes(target)) {
    if (parseNumber(data[target][idx][target]) === parseNumber(data[target][idx-1][target])) return true
    return false
  } else {
    if (data[target][idx][target] === data[target][idx-1][target]) return true
    return false
  }
}

export const bSearchForPR = (standard, score, reverse=false) => {
  if (score === '-') return '-'
  let lb = -1, ub = standard.length, mid = Math.floor((lb+ub)/2), val = score
  if (isNaN(score)) val = parseNumber(score)
  //console.log(standard, val)
  if (!reverse) {
    while (lb !== ub-1) {
      if (standard[mid] >= val) {
        lb = mid
      } else {
        ub = mid
      }
      mid = Math.floor((lb+ub)/2)
    }
  } else {
    while (lb !== ub-1) {
      if (standard[mid] <= val) {
        lb = mid
      } else {
        ub = mid
      }
      mid = Math.floor((lb+ub)/2)
    }
  }

  return standard.length - 1 - lb
}

export const bSearchPRCalc = (arr, val, rev=false) => {
  let lb = 0, ub = arr.length-1, mid = Math.floor((lb+ub)/2)
  if (!rev) {
    if (arr[0] >= val) return 0
    while (lb !== ub-1) {
      if (arr[mid] < val) lb = mid
      else ub = mid
      mid = Math.floor((lb+ub)/2)
    }
  } else {
    if (arr[0] <= val) return 0
    while (lb !== ub-1) {
      if (arr[mid] > val) lb = mid
      else ub = mid
      mid = Math.floor((lb+ub)/2)
    }
  }
  return Math.round(100*(lb+1)/arr.length)
}